import { useState, useEffect } from "react";
import { BottomDescList } from "./BottomDescList";
import styles from "./PricePolicy.module.css";

import ft_01 from "../../img/ft_01.png";
import ft_02 from "../../img/ft_02.png";
import ft_03 from "../../img/ft_03.png";
import ft_04 from "../../img/ft_04.png";
import ft_05 from "../../img/ft_05.png";
import ft_06 from "../../img/ft_06.png";
import { Color, PaymentData } from "../common/Common";

// 25.08.28 | Kim Young Jun | 로그인 상태 및 구독 상태에 따른 버튼 텍스트/스타일 분기를 위한 Props 추가
interface PricePolicyProps {
    onClick: () => void;
    isLoggedIn: boolean;    // 추가: 로그인 상태
    isSubscribed: boolean;  // 추가: 구독 상태
}

/**
 * @author mj
 * @date 2022-09-19 16:42:55
 * @remark 가격 정책 컴포넌트(지도만들기 하단 설명 컴포넌트 재사용)
 * @param props PricePolicyProps
 * @props onClick(required): 가입하기 버튼 클릭 시 실행 콜백
 * @returns <section>
 */
// 25.08.28 | Kim Young Jun | 구독 상태에 따른 버튼 UI 분기 처리 (가입하기/구독중)
// 로그인 및 구독 상태를 props로 받아 적절한 버튼 스타일과 텍스트 표시
function PricePolicy(props: PricePolicyProps) {
    
    const [isMobileView, setIsMobileView] = useState(false);
    

    // 반응형 MobileSize
    useEffect(() => {
        const checkViewport = () => {
            if (window.innerWidth <= 1350) {
                setIsMobileView(true);
            } else {
                setIsMobileView(false);
            }
        };

        checkViewport();
        window.addEventListener("resize", checkViewport);
        return () => window.removeEventListener("resize", checkViewport);
    }, []);
    
    // 스크롤바 맨 위로 이동
    window.scrollTo(0, 0);
    
    const pricePolicyListItem = [
        {
            src: ft_01,
            tit: "더 빠른 속도",
            des: ["일반 사용자 보다 많은 자원을\n활용하여 더 빠른 속도로 지도\n변환이 가능합니다."],
        },
        {
            src: ft_02,
            tit: "더 많은 지역 변환",
            des: ["지도당 최대 20,000건의\n데이터 변환이 가능합니다.\n(일반 사용자 : 500건)"],
        },
        {
            src: ft_03,
            tit: "내보내기 기능",
            des: ["<b>모두의지도</b>로 제작되어 생성된\n지도데이터를 다양한 종류의\n파일 형식으로 내보내기가 가능합니다."],
        },
        {
            src: ft_04,
            tit: "데이터 분석",
            des: ["직관적 데이터 표현방법인\n히트맵으로 시각적 분석이 가능합니다."],
        },
        {
            src: ft_05,
            tit: "지도 편집 기능",
            des: ["제작된 지도에 개별적인\n편집을 통해 마커 추가가 가능합니다."],
        },
        {
            src: ft_06,
            tit: "이동 경로 검색",
            des: ["길찾기 엔진을 활용한 최적의\n길찾기 서비스를 제공하며\n도로 네트워크 기반의 영역을\n검출한 반경검색을 제공합니다."],
        },
    ];
    const pricePolicyDescItem = [
        {
            src: "",
            tit: "✔ 더 빠른 속도",
            des: [],
        },
        {
            src: "",
            tit: "✔ 데이터 분석",
            des: [],
        },
        {
            src: "",
            tit: "✔ 더 많은 지역 변환",
            des: [],
        },
        {
            src: "",
            tit: "✔ 지도 편집 기능",
            des: [],
        },
        {
            src: "",
            tit: "✔ 내보내기 기능",
            des: [],
        },
        {
            src: "",
            tit: "✔ 이동 경로 검색",
            des: [],
        },
    ];

    return (
        <div className={styles.wrapper}>
            <section className={styles.purchase}>
                <div className={styles.desc_bx}>
                    <h2 className={[styles.tit, styles.blue].join(" ")}>모두의지도 PRO</h2>
                    <p className={styles.sub_tit}>
                        더 빠르게 편리하게
                        <br />
                        지도만들기
                    </p>
                    <p className={styles.desc}>더욱 많아진 데이터 처리와 다양한 분석 기법으로 더 빠른 지오코딩을 할 수 있습니다.</p>
                    <p className={styles.desc}>
                        <b className={styles.st}>매월 20,000원</b>으로 PRO기능을 정기구독하여 더욱 다양한 기능을 사용해보세요!
                    </p>
                    <br />
                    <br />
                    <p className={styles.desc}>원하는 결제방법 중 하나를 선택하여 1개월 단위로 PRO 기능을 구독할 수 있습니다.</p>
                </div>
                <div className={styles.join_bx}>
                    <p className={styles.price}>
                        20,000원 <span>매월</span>
                    </p>
                    <BottomDescList
                        col={2}
                        containerWidth={456}
                        contentWidth={228}
                        data={pricePolicyDescItem}
                        titStyle={!isMobileView ? {
                            margin: "5px 25px",
                            fontSize: "20px",
                            fontFamily: "NotoSansB",
                            color: Color.MAIN,
                            display: "inline-block",
                        } : {
                            margin: "5px 25px",
                            fontSize: "16px",
                            fontFamily: "NotoSansB",
                            color: Color.MAIN,
                            display: "inline-block",
                        }}
                    />
                    {/* 25.08.28 | Kim Young Jun | 구독 상태에 따른 버튼 텍스트 및 스타일 분기 처리 */}
                    <button 
                        onClick={props.onClick}
                        className={props.isSubscribed ? styles.subscribedButton : styles.subscribeButton}
                    >
                        {props.isSubscribed ? "구독 중" : "가입하기"}
                    </button>
                </div>
            </section>
            <section className={styles.pro}>
                <h3 className={styles.tit}>모두의지도 PRO 기능</h3>
                <BottomDescList
                    col={2}
                    containerWidth={1440}
                    contentWidth={720}
                    data={pricePolicyListItem}
                    titStyle={!isMobileView ? {
                        fontSize: "32px",
                        color: "#4e4e4e",
                        margin: "26px 0",
                        fontFamily: "NotoSansB",
                        textAlign: "left",
                    } : {
                        fontSize: "22px",
                        color: "#4e4e4e",
                        margin: "20px 0",
                        fontFamily: "NotoSansB",
                        textAlign: "left",
                    }}
                    desStyle={!isMobileView ? {
                        fontSize: "20px",
                        color: "#4e4e4e",
                        fontWeight: 400,
                    } : {
                        fontSize: "16px",
                        color: "#4e4e4e",
                        fontWeight: 400,
                    }}
                />
            </section>
        </div>
    );
}

export default PricePolicy;
